<template lang="pug">
.country-picker
  el-select(
    v-bind="$attrs",
    v-model="model",
    :id="id",
    filterable,
    :placeholder="$t('country')",
    clearable,
    :aria-describedby="ariaDescribedby",
    :aria-invalid="ariaInvalid",
    :aria-required="ariaRequired",
    :disabled="disabled"
  )
    template(#prefix)
      .fi.prefix(v-if="model", :class="`fi-${model.toLowerCase()}`")
    el-option(
      v-for="item in countries",
      :key="item.key",
      :label="item.value",
      :value="item.key"
    )
      .flex.flex-center
        .fi.mr-1(:class="`fi-${item.key.toLowerCase()}`")
        span {{ item.value }}
</template>

<script lang="ts" setup>
import { getAllCountries } from "@/utils/countries";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  modelValue?: string;
  id?: string;
  ariaDescribedby?: string;
  ariaInvalid?: boolean;
  ariaRequired?: boolean;
  disabled?: boolean;
}>();

const { t } = useI18n();

const countries = computed(() => {
  const c = getAllCountries();
  const countryKeyValues = Object.keys(c).map((code) => ({
    key: code,
    value: c[code],
  }));
  return countryKeyValues;
});
const emit = defineEmits<{
  "update:modelValue": [value: string | undefined];
}>();

const model = computed({
  get(): string | undefined {
    return props.modelValue;
  },
  set(value: string | undefined): void {
    emit("update:modelValue", value);
  },
});
</script>
<style>
.country-picker {
  flex: 1 0;
  position: relative;
}
</style>
